module.exports = __webpack_public_path__ + "static/media/logo_small_icon_only_inverted.49f1dae7.png";